import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useCompany } from "@/contexts/CompanyContext";
import { reportKeyFromPath } from "@/lib/reportViews";

const WINDOW_MS = 60_000;

/**
 * Records one lightweight event when a report page is opened.
 * De-duplicated per (company + report) within a one-minute window
 * so re-renders / filter changes do not inflate the count.
 */
export const ReportViewTracker = () => {
  const { pathname } = useLocation();
  const { currentCompany } = useCompany();
  const companyId = currentCompany?.id;

  useEffect(() => {
    const reportKey = reportKeyFromPath(pathname);
    if (!reportKey || !companyId) return;

    const storageKey = `sida:rv:${companyId}:${reportKey}`;
    const last = Number(sessionStorage.getItem(storageKey) || 0);
    if (Date.now() - last < WINDOW_MS) return;
    sessionStorage.setItem(storageKey, String(Date.now()));

    (async () => {
      const { data: auth } = await supabase.auth.getUser();
      const uid = auth?.user?.id;
      if (!uid) return;
      await (supabase as any)
        .from("report_view_events")
        .insert({ company_id: companyId, user_id: uid, report_key: reportKey });
    })().catch(() => {
      /* tracking must never break the report */
    });
  }, [pathname, companyId]);

  return null;
};
